<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2 class="m-0">Edit access</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p style="margin-bottom: 30px; color: #888">
    Control the functionality and section access for this employee/staff in your
    business. Allow or block access by checking or un-checking them from the
    below list.
  </p>
  <div class="row">
    <div class="col-sm-6" *ngFor="let item of functionalityList; let i = index">
      <div class="access-section">
        <mat-checkbox
          class="example-margin"
          [value]="item"
          (change)="selectFunctionality($event, i)"
          [checked]="item.access_status == 1"
          >{{ item.functionality_name }}</mat-checkbox
        >
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button (click)="onsave()" mat-flat-button color="accent">Save</button>
</mat-dialog-actions>
